const s = {
  name: "UsersBag",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,0c4.4,0,8,3.6,8,8c0,4.4-3.6,8-8,8s-8-3.6-8-8C10,3.6,13.6,0,18,0z M12,8c0,3.3,2.7,6,6,6s6-2.7,6-6
			s-2.7-6-6-6S12,4.7,12,8z"/>
		<path class="st0" d="M0,40V29c0-6.1,4.9-11,11-11h7v2h-7c-5,0-9,4-9,9v11H0z"/>
		<path class="st0" d="M8,30H6v10h2V30z"/>
		<path class="st0" d="M33,23h2.9L38,40H19l2.1-17H24v-1.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5V23z M28.5,19c-1.4,0-2.5,1.1-2.5,2.5
			V23h5v-1.5C31,20.1,29.9,19,28.5,19z M32.9,25h-10l-1.6,13h10L32.9,25z M34.5,28.1L33.3,38h2.4L34.5,28.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UsersBag
};
